import {
  FETCH_BRIEF_PROJECTS,
  RECEIVE_BRIEF_PROJECTS,
} from '../constants';

const initialState = {
  isLoading: false,
  projects: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRIEF_PROJECTS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case RECEIVE_BRIEF_PROJECTS: {
      const { projects } = action;
      return {
        ...state,
        projects,
        isLoading: false,
      };
    }
    default:
      return state;
  }
};

